module.exports = __webpack_public_path__ + "static/media/website.a223c187.svg";